import React from 'react';
import {inject, observer} from 'mobx-react';

import IntroStep5 from './portalintro/IntroStep5';

@inject('portalThemeStore')
@observer
class E9Account extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const {portalThemeStore} = this.props;
        portalThemeStore.getAccount();
        portalThemeStore.getAccountMoreMenu();
    }

    render() {
        return (
            <div className="e9header-account">
                <IntroStep5/>
            </div>
        );
    }
}

export default E9Account;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9Account.js